export class ViewStateFilterVisibility {
    public static HIDDEN: number = 1;
    public static VISIBLE: number = 2;
    public static NONE: number = 3;
}
